import React from 'react'
import ProfileRagComponent from '../../components/Profile/Rag'

export default function ProfileRag () {
  return (
    <ProfileRagComponent/>
  )
}
